<template>
  <div class="container">
    <div class="p-grid" v-if="item">
      <div
        class="imageContainer"
        :style="`background-image: url(${item.imagen})`"
      ></div>
      <div class="p-field p-col-12 p-text-center p-mb-0 p-mt-6">
        <h1 class="p-mb-0 titulo">{{ item.titulo.toUpperCase() }}</h1>
      </div>
      <div class="p-field p-col-12 p-text-center p-mb-0">
        <p class="autores">
          {{ $t("messages.author") }}: {{ item.autor }} / {{ $t("messages.published") }}:
          {{ formatDate(item.fecha_publicacion) }}
        </p>
      </div>
      <hr class="p-d-flex divisor" />
      <div class="p-field p-col-12 p-text-center">
        <p class="cuerpo"><span v-html="item.cuerpo"></span></p>
      </div>
      <div class="p-field p-col-12 p-text-center">
        <p class="referencias">{{ $t("messages.references") }}: {{ item.referencias }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import ArticulosService from "../service/articulos.service";
export default {
  metaInfo: {
    title: 'Detalle artículo - QualityCare',
    htmlAttrs: {
      lang: 'es',
    },
    meta: [
      {
        name: 'Detalle artículo - QualityCare',
        content: 'Se muestra el detalle de un artículo del blog, para que los usuarios puedan leerlo'
      },
    ],
  },
  name: "articulos",
  data() {
    return {
      articulosService: null,
      item: null,
      loading: false,
      id: 0,
    };
  },
  created() {
    this.articulosService = new ArticulosService();
    this.id = this.$route.params.id;
  },
  mounted() {
    this.getArticulo();
  },
  methods: {
    getArticulo() {
      this.loading = true;
      this.articulosService
        .getArticuloById(this.id)
        .then((result) => {
          if (result.data.data.length == 0) {
            this.item = null;
          } else {
            this.item = { ...result.data.data };
          }
        })
        .catch((err) => {
          console.log(err);
          this.$toast.add({
            severity: "error",
            summary: this.$t("messages.error"),
            detail: this.$t("messages.errorRetrievingInformation"),
            life: 3000,
          });
          this.loading = false;
        });
    },
    formatDate(fecha) {
      return new Date(fecha).toLocaleDateString("en-GB");
    },
  },
};
</script>

<style scoped>
.container {
  padding: 20px 300px;
  min-height: 600px;
}
.titulo {
  font-weight: bold;
  color: #205fa1;
}
.autores {
  font-weight: 700;
}
.cuerpo {
  text-align: justify;
  margin: 0px;
  font-size: 22px;
}
.referencias {
  text-align: justify;
  margin: 0px;
  font-size: 15px;
}
.imageContainer {
  height: 300px;
  width: 100%;
  background-repeat: no-repeat;
  background-size: cover;
}
@media screen and (max-width: 1450px) {
  .container {
    padding: 20px 20px;
  }
}
@media screen and (max-width: 800px) {
  .imageContainer {
    height: 150px;
    width: 100%;
    background-size: cover;
  }
  .titulo {
    font-size: 20px;
  }
  .cuerpo {
    text-align: justify;
    margin: 0px;
    font-size: 15px;
  }
  .container {
    padding: 10px 10px;
  }
}
</style>
